import initAboutSliders from './components/about-slider';
import initHoverLinks from './components/hover-links';
import initAboutImageSliders from './components/about-image-slider';

const aboutSliders = document.querySelectorAll('.js-about-slider');

if (aboutSliders && aboutSliders.length > 0) {
    initAboutSliders(aboutSliders);
}

const hoverLinks = document.querySelectorAll('.js-hover-links');

if (hoverLinks && hoverLinks.length > 0) {
    initHoverLinks(hoverLinks);
}

const aboutImageSliders = document.querySelectorAll('.js-about-image-slider');

if (hoverLinks && hoverLinks.length > 0) {
    initAboutImageSliders(aboutImageSliders);
}
